import React from 'react';
import { Container } from 'react-bootstrap';

const Contact = () => {
  return (
    <Container className="contact-page">
      <h1 className="text-center my-4">Contact Us</h1>
      <p className="text-center">
        If you would like us to link to you please email us at <a href="mailto:muscletease@gmail.com">muscletease@gmail.com</a>
      </p>
    </Container>
  );
};

export default Contact;
